export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./email-confirmation.vue?vue&type=template&id=06f5e024"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/quick-login-reg/email-confirmation.vue?vue&type=template&id=06f5e024
// module id = nLtr
// module chunks = 0